import { ShieldPlusIcon } from './ShieldPlusIcon';

/**
 * author: Google
 * id 872F02FE-ABEF-4187-B6B2-87A548988EAA
 * name shield-plus
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-plus.svg
 * tags
 */
export const ShieldAddIcon = ShieldPlusIcon;
export default ShieldAddIcon